import React, { useEffect } from "react";
import { ref } from "firebase/database";
import { rtdb } from "firebaseApp";
import { useObjectVal } from "react-firebase-hooks/database";
import MessageContainer from "components/chat/MessageContainer";
import CopyButton from "components/react-lib/generic-ui/CopyButton";
import { useTheme } from "@emotion/react";
import MarkdownBlock from "components/react-lib/markdown-code/MarkdownBlock";
import { fonts } from "fonts";
import { toast } from "react-hot-toast";
import ShimmeringText from "components/chat-v2/ShimmeringText";
import { useDispatch, useSelector } from "react-redux";
import { chatActions } from "../../store/chat";

export default function Message({
  message,
  inContext,
  canDelete = true,
  canUseAsPrompt = true,
  onData = () => {},
}) {

  const theme = useTheme();

  const conversationId = message.conversationId;

  const conversationStreamRef =
    conversationId && message.streaming
      ? ref(rtdb, `streams/${message.uid}/${message.id}/${conversationId}`)
      : null;


  const [data, loading, error] = useObjectVal(conversationStreamRef);

  if(error) {
    console.log(error);
  }

  const dispatch = useDispatch();
  // const localStream = useSelector((state) => state.chat.localStream);

  useEffect(() => {
    dispatch(chatActions.setLocalStream(data));
    if (data && onData) {
      onData(data);
    }
  }, [data, onData]);

  const renderBottomContent = () => {
    if (message.streaming) return null;
    return <CopyButton color="white" />;
  };

  const renderStreamingMessage = () => {
    if (!data || loading) {
      return renderMessage(<ShimmeringText>Starting...</ShimmeringText>);
    }
    if (!data.text) {
      return renderMessage(<ShimmeringText>{data.info}</ShimmeringText>);
    }
    return renderMessage(
      <MarkdownBlock
        markdownContent={data.text}
        canCopyCode={true}
        rawTextColor={theme.palette.text.main}
        rawCopyButtonColor={theme.palette.text.main}
        style={{
          color: theme.palette.text.main,
          lineHeight: 1.5,
          fontFamily: fonts.geist,
          overflowX: "auto",
        }}
      />
    );
  };

  const renderMessage = (children) => {
    return (
      <MessageContainer
        key={message.id}
        message={message}
        bottomContent={renderBottomContent()}
        inContext={inContext}
        canDelete={canDelete}
        canUseAsPrompt={canUseAsPrompt}
      >
        {children}
      </MessageContainer>
    );
  };

  const render = () => {
    if (message.streaming) {
      return renderStreamingMessage();
    }
    return renderMessage(
      <MarkdownBlock
        markdownContent={message.content}
        canCopyCode={true}
        rawTextColor={theme.palette.text.main}
        rawCopyButtonColor={theme.palette.text.main}
        style={{
          color: theme.palette.text.main,
          lineHeight: 1.5,
          fontFamily: fonts.geist,
          overflowX: "auto",
        }}
        onCopy={() => toast.success("Copied")}
      />
    );
  };

  return render();
}
